// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/shared/ExecutiveSummaryCard.jsx

import React from 'react';
import MissionMetric from './MissionMetric';

export default function ExecutiveSummaryCard({ brief = {} }) {
  const metrics = brief.metrics || [];
  return (
    <section className="executive-summary-card">
      <div>
        <p className="mission-launch-eyebrow">Executive Mission Brief</p>
        <h3>{brief.title || 'Compliance Operations Center established'}</h3>
        <p>{brief.summary || 'OASYS has built the first operating view of your organization’s compliance posture.'}</p>
      </div>
      <div className="mission-metric-grid">
        {metrics.map((metric) => (
          <MissionMetric key={metric.label} {...metric} compact />
        ))}
      </div>
    </section>
  );
}
